/* Linea Garden — carrello su misura (lato browser).
   Prodotto venduto a m² (altezza × larghezza), prezzo €/m² per densità 3/4 fili.
   Il carrello vive in localStorage; il prezzo mostrato è una stima: al checkout
   un endpoint server RICALCOLA e crea l'ordine su misura (draft order). */
(function () {
  'use strict';
  var KEY = 'lg_cart_v1';
  var CFG = window.LG_CART_CONFIG || {};
  var CART_URL = CFG.cartUrl || '/pages/carrello';
  var CHECKOUT = CFG.checkoutEndpoint || '';
  var H_MIN = 60, H_MAX = 220;

  var listeners = [];

  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    emit();
  }
  function emit() {
    var items = read();
    updateCounts(items);
    renderDrawer(items);
    renderPage(items);
    listeners.forEach(function (fn) { try { fn(items); } catch (e) {} });
  }

  function uid() { return 'l' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }
  function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
  function eur(n) {
    try { return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    catch (e) { return n.toFixed(2) + ' €'; }
  }
  function dec2(n) { return n.toFixed(2).replace('.', ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function area(it) { return (num(it.h) * num(it.w)) / 10000; }
  function linePrice(it) { return round2(area(it) * num(it.unit) * (it.qty || 1)); }
  function subtotal(items) { return round2(items.reduce(function (s, it) { return s + linePrice(it); }, 0)); }
  function count(items) { return items.reduce(function (s, it) { return s + (it.qty || 1); }, 0); }

  // Normalizzazione condivisa fra add() e addMany(): stessa forma della riga, un solo posto da cambiare.
  function normalizza(it) {
    return {
      id: uid(),
      pid: it.pid || '', handle: it.handle || '', title: it.title || 'Design su misura',
      variantId: it.variantId || '', sku: it.sku || '',
      design: it.design || it.title || '', color: it.color || '', img: it.img || '',
      fili: parseInt(it.fili, 10) === 3 ? 3 : 4,
      h: Math.round(num(it.h)), w: Math.round(num(it.w)),
      qty: Math.max(1, parseInt(it.qty, 10) || 1),
      unit: num(it.unit),
      // Dall'assistente per l'ordine: nome della zona e nota del cliente, per l'ordine (16/10/2026).
      zona: String(it.zona || '').slice(0, 60), nota: String(it.nota || '').slice(0, 500)
    };
  }

  /* ---- API pubblica ---- */
  var API = {
    items: function () { return read(); },
    count: function () { return count(read()); },
    subtotal: function () { return subtotal(read()); },
    add: function (it) {
      var items = read();
      var item = normalizza(it);
      items.push(item); write(items); open();
      return item;
    },
    // Più righe in un solo giro: una sola scrittura, un solo drawer che si apre
    // (l'assistente per l'ordine manda fino a 50 righe insieme — Task 14).
    // opzioni.progetto (stringa, max 64): riaprire lo stesso link ?p=&t= (token
    // riusabile) non deve raddoppiare le righe — si tolgono prima quelle già
    // marcate con lo stesso progetto (fix round 1, Ruling 35). Dal 16/10/2026
    // `checkout()` manda anche `prog`: l'ordine Shopify lo porta come attributo
    // nascosto e il gestionale ritrova il progetto senza indovinarlo dalle misure.
    addMany: function (arr, opzioni) {
      if (!Array.isArray(arr) || arr.length === 0) return [];
      var progetto = (opzioni && typeof opzioni.progetto === 'string') ? opzioni.progetto.slice(0, 64) : '';
      var items = read();
      if (progetto) items = items.filter(function (it) { return it.prog !== progetto; });
      var nuovi = arr.map(normalizza);
      if (progetto) nuovi.forEach(function (it) { it.prog = progetto; });
      items = items.concat(nuovi);
      write(items); open();
      return nuovi;
    },
    setQty: function (id, q) {
      q = Math.max(1, parseInt(q, 10) || 1);
      var items = read().map(function (it) { if (it.id === id) it.qty = q; return it; });
      write(items);
    },
    remove: function (id) { write(read().filter(function (it) { return it.id !== id; })); },
    clear: function () { write([]); },
    open: open, close: close,
    onChange: function (fn) { if (typeof fn === 'function') listeners.push(fn); },
    checkout: checkout,
    _fmt: { eur: eur, dec2: dec2 }
  };
  window.LGCart = API;

  /* ---- Conteggio header ---- */
  function updateCounts(items) {
    var n = count(items);
    document.querySelectorAll('[data-lg-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  /* ---- Riga articolo (markup condiviso drawer + pagina) ---- */
  function itemRow(it, variant) {
    var meta = 'Altezza ' + it.h + ' cm · Lunghezza ' + it.w + ' cm · ' + it.fili + ' fili · ' + dec2(area(it)) + ' m²';
    var thumb = it.img
      ? '<span class="lg-ci__im"><img src="' + esc(it.img) + '" alt="" loading="lazy"></span>'
      : '<span class="lg-ci__im lg-ci__im--ph"></span>';
    return '<div class="lg-ci" data-ci="' + it.id + '">' +
      thumb +
      '<div class="lg-ci__main">' +
        '<div class="lg-ci__top"><span class="lg-ci__name">' + esc(it.design || it.title) + '</span>' +
          '<button class="lg-ci__rm" type="button" data-rm aria-label="Rimuovi">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button></div>' +
        (it.color ? '<span class="lg-ci__col">' + esc(it.color) + '</span>' : '') +
        (it.zona ? '<span class="lg-ci__col">' + esc(it.zona) + '</span>' : '') +
        '<span class="lg-ci__meta">' + esc(meta) + '</span>' +
        '<div class="lg-ci__row">' +
          '<span class="lg-ci__qty"><button type="button" data-dec aria-label="Diminuisci">−</button><span data-q>' + it.qty + '</span><button type="button" data-inc aria-label="Aumenta">+</button></span>' +
          '<span class="lg-ci__price">' + eur(linePrice(it)) + '</span>' +
        '</div>' +
      '</div></div>';
  }

  function wireRows(scope) {
    scope.querySelectorAll('[data-ci]').forEach(function (row) {
      var id = row.getAttribute('data-ci');
      var q = row.querySelector('[data-q]');
      var dec = row.querySelector('[data-dec]'), inc = row.querySelector('[data-inc]'), rm = row.querySelector('[data-rm]');
      if (dec) dec.addEventListener('click', function () { var v = Math.max(1, parseInt(q.textContent, 10) - 1); API.setQty(id, v); });
      if (inc) inc.addEventListener('click', function () { var v = parseInt(q.textContent, 10) + 1; API.setQty(id, v); });
      if (rm) rm.addEventListener('click', function () { API.remove(id); });
    });
  }

  /* ---- Drawer ---- */
  function drawer() { return document.querySelector('[data-lg-drawer]'); }
  function open() { if (document.querySelector('[data-lg-cart-page]')) return; var d = drawer(); if (!d) { location.href = CART_URL; return; } d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('lg-cart-open'); }
  function close() { var d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lg-cart-open'); }

  function renderDrawer(items) {
    var d = drawer(); if (!d) return;
    var body = d.querySelector('[data-lg-items]');
    var foot = d.querySelector('[data-lg-foot]');
    if (!body || !foot) return;
    if (!items.length) {
      body.innerHTML = '<div class="lg-cartd__empty"><p>Il tuo carrello è vuoto.</p><a class="lg-cbtn lg-cbtn--secondary" href="' + esc(CART_URL === '/pages/carrello' ? '/collections' : '/collections') + '">Esplora i design</a></div>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = items.map(function (it) { return itemRow(it); }).join('');
    wireRows(body);
    foot.innerHTML =
      '<div class="lg-cartd__sub"><span>Totale stimato</span><strong>' + eur(subtotal(items)) + '</strong></div>' +
      '<p class="lg-cartd__note">Prodotto su misura, realizzato dopo l\'ordine. Spedizione e tasse calcolate al pagamento.</p>' +
      '<button class="lg-cbtn lg-cbtn--primary lg-cartd__go" type="button" data-checkout>Vai al pagamento</button>' +
      '<a class="lg-cartd__view" href="' + esc(CART_URL) + '">Vedi il carrello completo</a>';
    var go = foot.querySelector('[data-checkout]');
    if (go) go.addEventListener('click', function () { checkout(go); });
  }

  /* ---- Pagina carrello ---- */
  function renderPage(items) {
    var host = document.querySelector('[data-lg-cart-page]'); if (!host) return;
    if (!items.length) {
      host.innerHTML = '<div class="lg-cartp__empty"><h2 class="lg-h2">Il tuo carrello è vuoto</h2><p>Configura il tuo primo telo su misura.</p><a class="lg-cbtn lg-cbtn--primary" href="/collections">Esplora i design</a></div>';
      return;
    }
    host.innerHTML =
      '<div class="lg-cartp__grid">' +
        '<div class="lg-cartp__items">' + items.map(function (it) { return itemRow(it); }).join('') + '</div>' +
        '<div class="lg-cartp__sum">' +
          '<h2>Riepilogo</h2>' +
          '<div class="lg-cartp__row"><span>Totale stimato</span><strong>' + eur(subtotal(items)) + '</strong></div>' +
          '<p class="lg-cartp__note">Il prezzo definitivo, con spedizione e tasse, viene calcolato al pagamento. Prodotto su misura, realizzato dopo l\'ordine.</p>' +
          '<button class="lg-cbtn lg-cbtn--primary lg-cartp__go" type="button" data-checkout>Vai al pagamento</button>' +
          '<a class="lg-cartp__cont" href="/collections">Continua a scegliere</a>' +
        '</div>' +
      '</div>';
    wireRows(host);
    var go = host.querySelector('[data-checkout]');
    if (go) go.addEventListener('click', function () { checkout(go); });
  }

  /* ---- Checkout ---- */
  /* Il contatto che il cliente ha lasciato all'assistente (lo salva
     lg-consulente.liquid quando l'app lo manda al negozio). Va al server perché
     il checkout parta già con la sua email e l'ordine finisca sullo stesso
     cliente Shopify. Si legge solo quello che serve, come testo. */
  function contatto() {
    try {
      var c = JSON.parse(localStorage.getItem('lg_contatto'));
      if (!c || typeof c.email !== 'string' || !c.email) return null;
      return { email: c.email, nome: typeof c.nome === 'string' ? c.nome : null };
    } catch (e) { return null; }
  }

  function checkout(btn) {
    var items = read();
    if (!items.length) return;
    if (!CHECKOUT) {
      window.alert('Il pagamento sarà attivo a breve. Stiamo completando il collegamento del checkout su misura.');
      return;
    }
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Attendi…'; }
    var payload = {
      items: items.map(function (it) {
        return { variantId: it.variantId, sku: it.sku, pid: it.pid, handle: it.handle, title: it.title, design: it.design, color: it.color, fili: it.fili, h: it.h, w: it.w, qty: it.qty, zona: it.zona, nota: it.nota, prog: it.prog };
      })
    };
    var c = contatto();
    if (c) payload.contatto = c;
    fetch(CHECKOUT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j && res.j.invoiceUrl) { window.location.href = res.j.invoiceUrl; }
        else { throw new Error((res.j && res.j.error) || 'Errore checkout'); }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Vai al pagamento'; }
        window.alert('Qualcosa è andato storto nel creare l\'ordine. Riprova o scrivici.');
      });
  }

  /* ---- Init ---- */
  function init() {
    // Apri il drawer dai trigger (icone carrello header)
    document.querySelectorAll('[data-lg-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    var d = drawer();
    if (d) {
      d.querySelectorAll('[data-lg-close]').forEach(function (el) { el.addEventListener('click', close); });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    emit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
